import { Tooltip, Typography } from "antd";
import { StyledFlex } from "../Table/index.styled";
import { Customer } from "@lib/types/Customer";
import { Link } from "react-router-dom";
import { getRoute } from "@lib/helpers/RouteHelper";
import { ROUTES } from "@lib/constants";
import { useTypedSelector } from "@lib/redux";
import { AuthRoles } from "@lib/types/Auth";
import { useMemo } from "react";
import { CustomerLogo } from "@lib/components/MiniComponents/Others";
import { AvatarSize } from "@lib/types/General";

type Props = {
  customer: Customer;
  link?: boolean;
  logoWidth?: number;
  titleMaxLength?: number;
  preview?: boolean;
  size?: AvatarSize;
  noLogo?: boolean;
};

export default function CustomerName({
  customer,
  link,
  size = "medium",
  noLogo = false,
}: Props) {
  const { user } = useTypedSelector((state) => state.auth);

  const customerName = customer?.name || " N/A ";

  const customerLink = useMemo(() => {
    if (!customer) return null;
    switch (user?.role) {
      case AuthRoles.Admin:
        return getRoute(ROUTES.ADMIN.CUSTOMER.DETAIL, {
          customerId: customer?.id,
        });
      default:
        return null;
    }
  }, [user]);

  if (!customer) return customerName;

  if (link && customerLink) {
    return (
      <StyledFlex style={{ gap: 5 }}>
        {!noLogo && (
          <Link to={customerLink}>
            <CustomerLogo customer={customer} size={size} />
          </Link>
        )}
        <Tooltip title={customerName}>
          <Typography.Text ellipsis={{ tooltip: customerName }}>
            <Link to={customerLink} style={{ cursor: "pointer" }}>
              {customerName}
            </Link>
          </Typography.Text>
        </Tooltip>
      </StyledFlex>
    );
  }

  return (
    <StyledFlex style={{ gap: 5 }}>
      {!noLogo && <CustomerLogo customer={customer} size={size} />}
      <Tooltip title={customerName}>
        <Typography.Text ellipsis={{ tooltip: customerName }}>
          {customerName}
        </Typography.Text>
      </Tooltip>
    </StyledFlex>
  );
}
